/**
 * Safari `<input type="time">` / `<input type="date">` commit safety net.
 *
 * Native time/date inputs in Safari can hold a typed-but-not-yet-blurred
 * value without firing React's onChange, so clicking Save can submit
 * stale formData. Calling `commitPendingInputs()` at the very start of a
 * Save handler forces Safari to commit any in-flight edits by blurring
 * the active element + yielding one microtask for React to process the
 * resulting onChange events.
 *
 * Defensive: also catches the same class of issue on regular text inputs
 * with browser autofill / IME composition in flight.
 *
 * Usage:
 *   const handleSave = async () => {
 *     await commitPendingInputs();
 *     // ...read formData, POST/PUT
 *   };
 */
export async function commitPendingInputs() {
  if (typeof document === "undefined") return;
  const active = document.activeElement;
  if (active && typeof active.blur === "function" && active !== document.body) {
    active.blur();
    // Yield one microtask so React processes the resulting change event
    // before the caller reads its controlled state.
    await new Promise((resolve) => setTimeout(resolve, 0));
  }
}
